import { useState } from 'react';
// Mobx
import { inject, observer } from 'mobx-react';
// Components
import useChatStore from 'Components/Chat/store';
import Modal from 'Components/Common/Modal/NewModal';
import useThemeStore from 'Theme/store';
// Icons
import { CheckIcon } from '@heroicons/react/24/outline';
import useTreeDNDChatStore from 'Components/Chat/TreeDNDChat/Store';
import toast from 'react-hot-toast';

const EditTitle = inject('store')(
  observer(({ store, chat, onInteraction }) => {
    const [title, setTitle] = useState(chat.title);
    const [isLoading, setIsLoading] = useState(false);
    const { theme } = useThemeStore();
    const { selectedChat } = useChatStore();
    const { treeData, setTreeData } = useTreeDNDChatStore();

    const handleEdit = async () => {
      if (!title?.trim()) return;

      setIsLoading(true);
      try {
        await store.api.post('/chat/edit', {
          hash: chat._id,
          title: title.trim(),
        });

        toast.success('Information updated');

        // Update tree data
        const updatedTreeData = treeData.map(item =>
          item.id === chat._id ? { ...item, text: title.trim() } : item
        );
        setTreeData(updatedTreeData);

        onInteraction({ title: title.trim() });
      } catch (error) {
        toast.error('Failed to update title');
        console.error('Error updating title:', error);
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <Modal
        open={true}
        title="Edit title"
        onClose={() => onInteraction('close')}
        onConfirm={handleEdit}
        buttonConfirmProps={{
          disabled: !title?.trim() || isLoading,
        }}
        onConfirmBtnText="Update"
        onConfirmBtnIcon={
          <CheckIcon className="h-[18px] w-[18px]" aria-hidden="true" />
        }
      >
        <div className="font-figtree w-96 text-base text-black dark:text-crystal-bell text-center">
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            type="text"
            className={`w-full border border-platinum text-sm leading-[18px] ${theme === 'dark'
              ? 'bg-lead text-crystal-bell'
              : 'bg-white text-raisin-black'
              } border-solid px-3 py-2 rounded-[10px] mb-2`}
            placeholder="New chat title"
          />
        </div>
      </Modal>
    );
  })
);

export default EditTitle;
